import { initialState } from '../reducers/rightPanel';
import { peek, selector } from '../selectorHelpers';

export const selectPanel = (state) => state.get('rightPanel', initialState);

export const panelSelectOpened = selector(selectPanel, peek('isOpen'));
export const panelSelectData = selector(selectPanel, peek('panelData'));
export const panelSelectType = selector(selectPanel, peek('panelType'));
